//@ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { Paperclip, X } from "lucide-react";
import CustomMenuDropdown from "../common/CustomMenuDropdown";
import { toast } from "sonner";
import {
  createTeamMessageThunk,
  deleteTeamMemberMessageData,
  fetchTeamMessagesListThunk,
  updateTeamMessageAsync,
} from "../../features/ApplicationData/ApplicationDataSlice";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { formatDistanceToNow } from "date-fns";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CrossIcon } from "../icons/Icons";
import { getColorForLabel } from "../../utils/colorUtils";
import { Mention, MentionsInput } from "react-mentions";
import { fetchJobPipelineDetailsData } from "../../features/hiringpipeline/hiringPipelineSlice";

// Customize the mentions input component
const MentionsTextarea = ({ value, onChange, placeholder, mentionData }) => {
  // Define the styling for the mentions input
  const mentionsInputStyle = {
    control: {
      minHeight: "60px",
      padding: "0px",
      fontSize: "13px",
      fontWeight: "normal",
      borderRadius: "0.375rem",

      backgroundColor: "transparent",
      width: "100%",
      overflow: "hidden",
      resize: "none",
      outline: "none",
      "&focused": {
        borderColor: "#4f46e5", // indigo-600
        boxShadow: "0 0 0 2px #4f46e5",
      },
    },
    highlighter: {
      padding: "7px 2px 2px 3px",
      minHeight: "60px",
      border: "none",
      // color: "#374151"
    },
    input: {
      padding: "6px",
      outline: "none",
      border: "none",
      minHeight: "60px",
      "&focused": {
        borderColor: "#4f46e5", // indigo-600
        boxShadow: "0 0 0 2px #4f46e5",
      },
    },
    // input focus

    suggestions: {
      list: {
        backgroundColor: "white",
        border: "1px solid #e5e7eb",
        borderRadius: "0.375rem",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        fontSize: "13px",
        fontWeight: "normal",
        overflow: "auto",
        maxHeight: "200px",
        width: "200px",
        zIndex: 10,
      },
      item: {
        padding: "0", // Remove padding from items
        "&focused": {
          backgroundColor: "transparent", // We'll style focused items manually
        },
      },
    },
  };

  const defaultMentionStyle = {
    // color: "#1e40af",
    // backgroundColor: "#cee4e5",
    // // padding: '2px 2px 2px 3px',
    // // borderRadius:
    // fontWeight: 'bold'
  };

  return (
    <MentionsInput
      value={value}
      onChange={onChange}
      style={mentionsInputStyle}
      placeholder={placeholder}
      a11ySuggestionsListLabel="Suggested team members"
    >
      <Mention
        trigger="@"
        data={mentionData}
        style={defaultMentionStyle}
        renderSuggestion={(
          suggestion,
          search,
          highlightedDisplay,
          index,
          focused,
        ) => (
          // Styled to match your dropdown UI example
          // <div
          //   className={`w-full ${focused ? 'bg-gray-200' : 'bg-white hover:bg-gray-100'}`}
          //   style={{
          //     padding: '8px 16px',
          //     cursor: 'pointer',
          //     borderBottom: index < mentionData.length - 1 ? '1px solid #e5e7eb' : 'none',
          //     transition: 'background-color 0.2s ease',
          //     overflow: 'hidden',
          //   }}
          // >
          //   <div className="flex items-center gap-2">
          //     {suggestion.profile_pic ? (
          //       <img
          //         src={`${process.env.REACT_APP_API_BASE_URL}/${suggestion.profile_pic}`}
          //         alt={suggestion.display}
          //         className="w-5 h-5 rounded-full flex-shrink-0"
          //       />
          //     ) : (
          //       <div
          //         style={{ backgroundColor: getColorForLabel(suggestion.display.charAt(0) || '') }}
          //         className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
          //       >
          //         <span className="font-medium text-white leading-6">
          //           {suggestion.display.charAt(0)}
          //         </span>
          //       </div>
          //     )}
          //     <span className="text-gray-800 font-normal">{suggestion.display}</span>
          //   </div>
          // </div>
          <div
            className={`w-full ${focused ? "bg-gray-200" : "bg-white hover:bg-gray-100"}`}
            style={{
              padding: "8px 16px",
              cursor: "pointer",
              borderBottom:
                index < mentionData.length - 1 ? "1px solid #e5e7eb" : "none",
              transition: "background-color 0.2s ease",
              overflow: "hidden", // Add this
            }}
          >
            <div className="flex items-center gap-2">
              {suggestion.profile_pic ? (
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/${suggestion.profile_pic}`}
                  alt={suggestion.display}
                  className="w-5 h-5 rounded-full flex-shrink-0" // Add flex-shrink-0 to prevent image from squeezing
                />
              ) : (
                <div
                  style={{
                    backgroundColor: getColorForLabel(
                      suggestion.display.charAt(0) || "",
                    ),
                  }}
                  className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" // Add flex-shrink-0 here too
                >
                  <span className="font-medium text-white leading-6">
                    {suggestion.display.charAt(0)}
                  </span>
                </div>
              )}

              {/* Update this span to handle truncation */}
              <span
                className="text-gray-800 font-normal truncate"
                style={{
                  display: "block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "135px", // Give it a max-width allowing room for the padding and avatar
                }}
                title={suggestion.display} // Optional: Shows the full name on hover
              >
                {suggestion.display}
              </span>
            </div>
          </div>
        )}
        displayTransform={(id, display) => `@${display}`}
        appendSpaceOnAdd
      />
    </MentionsInput>
  );
};

// Auto-resizing textarea component
const AutoResizeTextarea = ({ value, onChange, placeholder }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      // Reset height to auto to get the correct scrollHeight
      textareaRef.current.style.height = "auto";
      // Set the height based on scrollHeight with a minimum of 60px
      textareaRef.current.style.height = `${Math.max(60, textareaRef.current.scrollHeight)}px`;
    }
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      className="outline-none bg-transparent focus:outline-none focus:ring-0 text-[14px] text-dark-black-100 w-full m-0 placeholder:text-[#9e9ea0] border-1 border-solid border-light-gray-200 rounded-md p-2 min-h-[60px] overflow-hidden resize-none"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={1}
    />
  );
};

const EditMessageModal = ({
  isOpen,
  onClose,
  message,
  onSave,
  loadingMessageUpdate,
  pipelineStageDataUser,
}) => {
  const [updatedMessage, setUpdatedMessage] = useState("");
  const [structuredMessage, setStructuredMessage] = useState("");

  // Convert {{userId}} format to @[name](id) format when modal opens
  useEffect(() => {
    if (message?.message && isOpen && pipelineStageDataUser?.length > 0) {
      let formattedMessage = message.message;

      // Create a map of user IDs to names
      const userIdToNameMap = {};
      pipelineStageDataUser.forEach((user) => {
        if (user && user.id) {
          userIdToNameMap[user.id] = user.name;
        }
      });

      // Replace {{userId}} with @[username](userId)
      const mentionRegex = /\{\{(\d+)\}\}/g;
      formattedMessage = formattedMessage.replace(
        mentionRegex,
        (match, userId) => {
          const userName = userIdToNameMap[userId] || `User ${userId}`;
          return `@[${userName}](${userId})`;
        },
      );

      setStructuredMessage(formattedMessage);
    } else if (message?.message) {
      // If no mentions or user data not loaded yet, just set the raw message
      setStructuredMessage(message.message);
    }
  }, [message, isOpen, pipelineStageDataUser]);

  // Format mentionData for the react-mentions component, reusing the format from parent
  const mentionData =
    pipelineStageDataUser?.map((user) => ({
      id: user.id,
      display: user.name,
      profile_pic: user.profile_pic,
    })) || [];

  // Handle mention input changes
  const handleMentionInputChange = (
    e,
    newValue,
    newPlainTextValue,
    mentions,
  ) => {
    setStructuredMessage(newValue); // This will be like "message text @[username](userId)"
    setUpdatedMessage(newPlainTextValue); // This will be like "message text @username"
  };

  // Handle saving with proper mention formatting
  const handleSaveWithMentions = () => {
    // Extract user IDs from mentions in the structured format
    const mentionRegex = /@\[([^\]]+)\]\((\d+)\)/g;
    let match;
    const mentionMap = {};

    // Extract all mentions and build the map
    while ((match = mentionRegex.exec(structuredMessage)) !== null) {
      const userName = match[1];
      const userId = match[2];
      mentionMap[userName] = userId;
    }

    // Create the formatted message with {{id}} placeholders
    let formattedMessage =
      updatedMessage ||
      structuredMessage.replace(/@\[([^\]]+)\]\((\d+)\)/g, "@$1");

    // Replace @userName with {{userId}}
    Object.keys(mentionMap).forEach((name) => {
      const mentionPattern = new RegExp(`@${name}\\b`, "g");
      formattedMessage = formattedMessage.replace(
        mentionPattern,
        `{{${mentionMap[name]}}}`,
      );
    });

    onSave(formattedMessage);
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Edit Message
            </h3>
            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={onClose}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <CrossIcon />
              </button>
            </div>

            <div className="mt-5 team-textarea">
              <MentionsTextarea
                value={structuredMessage}
                onChange={handleMentionInputChange}
                placeholder="Edit message..."
                mentionData={mentionData}
              />
            </div>

            <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
              <button
                type="button"
                onClick={onClose}
                className="items-center px-[14px] py-1 text-[13px] font-medium h-[32px] inline-flex leading-6 w-fit justify-center rounded-md bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveWithMentions}
                type="button"
                className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 "
              >
                {loadingMessageUpdate ? (
                  <div className="flex items-center gap-[6px]">
                    Save
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  </div>
                ) : (
                  " Save"
                )}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

function JobMessageSection({ job: jobProp, app: appProp, quickData }) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [message, setMessage] = useState("");
  const [showButton, setShowButton] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  // const { baseId, jobId, applicationId } = useParams<{ baseId: string; jobId: string; applicationId: string }>();
  const {
    baseId,
    jobId: jobIdFromParams,
    applicationId: applicationIdFromParams,
  } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();

  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData;
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [loadingMessage, setLoadingMessage] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [loadingMessageUpdate, setLoadingMessageUpdate] = useState(false);
  const [openDeleteModalExp, setOpenDeleteModalExp] = useState(false);
  const [deleteLoadingExp, setDeleteLoadingExp] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [pipelineStageDataUser, setPipelineStageDataUser] = useState([]);
  const [saveMention, setSaveMention] = useState("");
  const [userId, setUserId] = useState(null);

  const handleEditClick = (message) => {
    setSelectedMessage(message);
    setIsModalOpen(true);
  };

  const handleSave = async (updatedMessageText) => {
    if (!updatedMessageText.trim()) {
      toast.error("Message cannot be empty");
      return;
    }

    setLoadingMessageUpdate(true);
    try {
      await dispatch(
        updateTeamMessageAsync({
          baseId: Number(baseId),
          id: selectedMessage?.id,
          messageContent: updatedMessageText,
        }),
      ).unwrap();
      toast.success("Message updated successfully!");
      setIsModalOpen(false);
      // Optionally, refresh the messages list
      const res = await dispatch(
        fetchTeamMessagesListThunk({
          baseId: Number(baseId),
          appID: applicationId,
          type: "message",
          page: page,
          limit: itemsPerPage,
        }),
      ).unwrap();
      if (res) {
        setMessages(res.data.messages);
        setShowButton(res);
      }
    } catch (error) {
      toast.error(error || "Failed to update message");
      setIsModalOpen(false);
    } finally {
      setLoadingMessageUpdate(false);
    }
  };

  useEffect(() => {
    const fetchMessages = async () => {
      if (baseId && jobId && applicationId) {
        setLoading(true);
        try {
          const res = await dispatch(
            fetchTeamMessagesListThunk({
              baseId: Number(baseId),
              appID: applicationId,
              type: "message",
              page: page,
              limit: itemsPerPage,
            }),
          ).unwrap();
          if (res) {
            // setMessages((prevMessages) => [...prevMessages, ...res.data.messages]);
            setMessages(res.data.messages);
            setShowButton(res);
          }
        } catch (error) {
          console.error("Error fetching messages:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchMessages();
  }, [baseId, jobId, applicationId, dispatch, page, itemsPerPage]);

  const handleLoadMore = () => {
    setItemsPerPage((prevItemsPerPage) => prevItemsPerPage);
    setPage((prevPage) => prevPage + 1);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      // Validate file type
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only PDF or DOC files are allowed.");
        return;
      }

      // Validate file size (20 MB limit)
      const maxSize = 20 * 1024 * 1024; // 20 MB in bytes
      if (file.size > maxSize) {
        toast.error("File size must be less than 20 MB.");
        return;
      }

      // If validation passes, set the selected file
      setSelectedFile(file);
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
  };

  // Format mentionData for the react-mentions component
  const mentionData = pipelineStageDataUser.map((user) => ({
    id: user.id,
    display: user.name,
    profile_pic: user.profile_pic,
  }));

  const handlePostMessage = async () => {
    if (!message.trim()) {
      toast.error("Message cannot be empty");
      return;
    }
    setLoadingMessage(true);

    // Extract user IDs from mentions in the structured saveMention format
    const mentionRegex = /@\[([^\]]+)\]\((\d+)\)/g;
    let match;

    // Create a map to store user name to ID mapping
    const mentionMap = {};

    // Extract all mentions and build the map
    while ((match = mentionRegex.exec(saveMention)) !== null) {
      const userName = match[1]; // The user's name
      const userId = match[2]; // The user's ID
      mentionMap[userName] = userId;
    }

    // Create the formatted message with {{id}} placeholders
    let formattedMessage = message;

    // Replace @userName with {{userId}}
    Object.keys(mentionMap).forEach((name) => {
      const mentionPattern = new RegExp(`@${name}\\b`, "g");
      formattedMessage = formattedMessage.replace(
        mentionPattern,
        `{{${mentionMap[name]}}}`,
      );
    });

    // Format may already be applied in some cases via the MentionsInput component
    // This handles any other @mentions that might not be properly formatted
    const directMentionRegex = /@(\w+)/g;
    formattedMessage = formattedMessage.replace(
      directMentionRegex,
      (match, name) => {
        // Find the matching user by name in pipelineStageDataUser
        const mentionedUser = pipelineStageDataUser.find(
          (user) => user.name.toLowerCase() === name.toLowerCase(),
        );
        return mentionedUser ? `{{${mentionedUser.id}}}` : match;
      },
    );

    const formData = new FormData();
    formData.append("job_id", jobId || "");
    formData.append("app_id", applicationId || "");
    formData.append("type", "message");
    formData.append("privacy", "public");
    formData.append("message", formattedMessage); // Using our formatted message with {{id}} placeholders
    // We still keep the mentions field for backward compatibility or other uses
    const mentionIds = Object.values(mentionMap);
    formData.append("mentions", mentionIds.join(","));

    if (selectedFile) {
      formData.append("attachment", selectedFile);
    }

    try {
      await dispatch(
        createTeamMessageThunk({ baseId: Number(baseId), formData }),
      ).unwrap();
      toast.success("Message posted successfully!");
      setMessage("");
      setSaveMention(""); // Clear the mentions
      setSelectedFile(null); // Clear the selected file after posting

      const res = await dispatch(
        fetchTeamMessagesListThunk({
          baseId: Number(baseId),
          appID: applicationId,
          type: "message",
          page: 1,
          limit: itemsPerPage,
        }),
      ).unwrap();
      if (res.data.messages) {
        setMessages(res.data.messages);
      }
    } catch (error) {
      console.error("Failed to post message:", error);
      toast.error("Failed to post message");
    } finally {
      setLoadingMessage(false);
    }
  };

  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}",
    );
    setUserId(storedUserDetails?.id); // Assuming the user ID is stored as 'id' in userDetails
  }, []);

  const handleCloseModal = () => {
    setOpenDeleteModalExp(false);
    setSelectedIndex(null); // Clear the selected index
  };

  const handleDeleteClick = (message) => {
    setSelectedIndex(message.id);
    setOpenDeleteModalExp(true);
  };

  const handleDeleteConfirm = async () => {
    setDeleteLoadingExp(true); // Start loading

    try {
      await dispatch(
        deleteTeamMemberMessageData({
          baseId: Number(baseId),
          id: selectedIndex,
        }),
      ).unwrap();

      toast.success("Message deleted successfully!");
      setOpenDeleteModalExp(false);
      // setSelectedFile(null)

      const res = await dispatch(
        fetchTeamMessagesListThunk({
          baseId: Number(baseId),
          appID: applicationId,
          type: "message",
          page: page,
          limit: itemsPerPage,
        }),
      ).unwrap();

      if (res) {
        setMessages(res.data.messages);
        setShowButton(res);
      }
    } catch (error) {
      toast.error("Failed to delete message!");
      console.error("Delete error:", error);
    } finally {
      setDeleteLoadingExp(false); // Stop loading
    }
  };

  useEffect(() => {
    if (baseId && jobId) {
      const fetchTeams = async () => {
        try {
          const baseMembersDetailsString = localStorage.getItem(
            "jobByHiringTeamMembers",
          );

          let baseMembers: any[] = [];

          if (baseMembersDetailsString) {
            const hiringTeamMembers =
              JSON.parse(baseMembersDetailsString) || [];

            const userList = hiringTeamMembers
              .map((member: any) => {
                return {
                  id: member.user_id,
                  name: member?.name || "Unknown User",
                  profile_pic: member?.profile_pic || null,
                };
              })
              .filter((user) => user.name !== "Unknown User");
            setPipelineStageDataUser(userList);
          } else {
            const baseResponse = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: parseInt(baseId),
                JobId: jobId,
              }),
            );

            const teamMemberData = baseResponse?.payload?.data?.teamMembers;
            // local stroage
            localStorage.setItem(
              "jobByHiringTeamMembers",
              JSON.stringify(teamMemberData),
            );
            if (!teamMemberData) {
              console.warn("No teamMember data returned from API.");
              return;
            }

            const hiringTeamMembers = Array.isArray(teamMemberData)
              ? teamMemberData
              : [];

            const userList = hiringTeamMembers
              .map((member: any) => {
                return {
                  id: member.user_id,
                  name: member?.name || "Unknown User",
                  profile_pic: member?.profile_pic || null,
                };
              })
              ?.filter((user) => user.name !== "Unknown User");

            setPipelineStageDataUser(userList);
          }
        } catch (error) {
          console.error("Error fetching team members:", error);
        }
      };

      fetchTeams();
    }
  }, [baseId, jobId, dispatch]);

  const handleMentionInputChange = (
    e,
    newValue,
    newPlainTextValue,
    mentions,
  ) => {
    setMessage(newPlainTextValue);
    setSaveMention(newValue);
  };

  return (
    <div>
      <div className="space-y-4">
        {showButton.hasNextPage === true && (
          <div className="flex justify-center mt-0">
            <button
              className="text-blue-500 leading-5 text-[12px] rounded-[60px] py-1 hover:ring-1 px-3 ring-inset ring-gray-500/10"
              type="button"
              onClick={handleLoadMore}
            >
              <span className="px-1">Load More</span>
            </button>
          </div>
        )}
        {loading ? (
          <div
            className="flex items-center justify-center relative z-50"
            style={{ height: "100px" }}
          >
            <div className="simple-spinner-loader">
              <span></span>
            </div>
          </div>
        ) : messages.length === 0 ? (
          <div className="w-full flex h-[100px] justify-center items-center flex-col gap-y-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-info-triangle  w-[1.5rem] h-[1.5rem] text-[#808080]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
              <path d="M12 9h.01" />
              <path d="M11 12h1v4h1" />
            </svg>
            <p className="text-[#0000007a] text-[13px]">No results found</p>
          </div>
        ) : (
          [...messages].reverse().map((msg, index) => {
            const senderUser =
              baseMembers.find((member) => member.user_id === msg.user_id) ||
              {};
            const senderName = senderUser.name
              ? senderUser.name
              : msg.candidate?.name;
            const senderImg = senderUser.profile_pic
              ? senderUser.profile_pic
              : msg.candidate?.image;

            const dropdownGroups = [
              {
                options: [
                  {
                    label: `Edit`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleEditClick(msg),
                  },
                  {
                    label: `Delete`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleDeleteClick(msg),
                    // onClick: async () => {
                    //   try {
                    //     await dispatch(
                    //       deleteTeamMemberMessageData({
                    //         baseId: Number(baseId),
                    //         id: msg.id,
                    //       })
                    //     ).unwrap();

                    //     toast.success("Message deleted successfully!");

                    //     const res = await dispatch(
                    //       fetchTeamMessagesListThunk({
                    //         baseId: Number(baseId),
                    //         appID: applicationId,
                    //         type: "team",
                    //         page: page,
                    //         limit: itemsPerPage,
                    //       })
                    //     ).unwrap();

                    //     if (res) {
                    //       setMessages(res.messages);
                    //       setShowButton(res);
                    //     }
                    //   } catch (error) {
                    //     toast.error("Failed to delete message!");
                    //     console.error("Delete error:", error);
                    //   }
                    // },
                  },
                ],
              },
            ];

            // const renderMessageWithMentions = (messageText, pipelineStageDataUser = []) => {
            //   if (!messageText) return '';

            //   // Safety check for pipelineStageDataUser
            //   if (!Array.isArray(pipelineStageDataUser)) {
            //     return messageText;
            //   }

            //   // Create a map of user IDs to names for quick lookup
            //   const userIdToNameMap = {};
            //   pipelineStageDataUser.forEach(user => {
            //     if (user && user.id) {
            //       userIdToNameMap[user.id] = user.name || `User ${user.id}`;
            //     }
            //   });

            //   // Replace {{userId}} with @username
            //   let formattedMessage = messageText;

            //   // Find all instances of {{userId}}
            //   const mentionRegex = /\{\{(\d+)\}\}/g;
            //   let match;

            //   // Process each mention match
            //   while ((match = mentionRegex.exec(messageText)) !== null) {
            //     const userId = match[1];
            //     const userName = userIdToNameMap[userId] || `User ${userId}`;

            //     // Replace the {{userId}} with @username
            //     formattedMessage = formattedMessage.replace(
            //       `{{${userId}}}`,
            //       `@${userName}`
            //     );
            //   }

            //   // Create React elements array for the final rendered message
            //   const elements = [];
            //   let lastIndex = 0;

            //   // Find all @mentions in the formatted message
            //   const atMentions = [];

            //   // First, build a list of all possible mentions
            //   pipelineStageDataUser.forEach(user => {
            //     if (user && user.name) {
            //       const mentionRegex = new RegExp(`@${user.name}\\b`, 'gi');
            //       let mentionMatch;

            //       while ((mentionMatch = mentionRegex.exec(formattedMessage)) !== null) {
            //         atMentions.push({
            //           index: mentionMatch.index,
            //           length: mentionMatch[0].length,
            //           name: user.name,
            //           userId: user.id
            //         });
            //       }
            //     }
            //   });

            //   // Sort mentions by their position in the text
            //   atMentions.sort((a, b) => a.index - b.index);

            //   // Build the final message with highlighted mentions
            //   atMentions.forEach((mention, idx) => {
            //     // Add text before the mention
            //     if (mention.index > lastIndex) {
            //       elements.push(
            //         <span key={`text-${idx}`}>
            //           {formattedMessage.substring(lastIndex, mention.index)}
            //         </span>
            //       );
            //     }

            //     // Add the highlighted mention
            //     elements.push(
            //       <span key={`mention-${idx}`} className=" text-blue-800 px-1 rounded">
            //         {formattedMessage.substring(mention.index, mention.index + mention.length)}
            //       </span>
            //     );

            //     lastIndex = mention.index + mention.length;
            //   });

            //   // Add any remaining text after the last mention
            //   if (lastIndex < formattedMessage.length) {
            //     elements.push(
            //       <span key="text-end">
            //         {formattedMessage.substring(lastIndex)}
            //       </span>
            //     );
            //   }

            //   // If no mentions were found, just return the plain text
            //   if (elements.length === 0) {
            //     return formattedMessage;
            //   }

            //   return <>{elements}</>;
            // };

            const renderMessageWithMentions = (
              messageText,
              pipelineStageDataUser = [],
            ) => {
              if (!messageText) return "";

              // Safety check for pipelineStageDataUser
              if (!Array.isArray(pipelineStageDataUser)) {
                return messageText;
              }

              // Create a map of user IDs to names for quick lookup
              const userIdToNameMap = {};
              pipelineStageDataUser.forEach((user) => {
                if (user && user.id) {
                  userIdToNameMap[user.id] = user.name || `User ${user.id}`;
                }
              });

              // Split the message by the mention pattern {{userId}}
              // The capturing group (...) ensures the matched markers are kept in the resulting array
              const parts = messageText.split(/(\{\{\d+\}\})/g);

              return parts.map((part, index) => {
                // Check if the current part is a mention marker like {{10015}}
                const match = part.match(/^\{\{(\d+)\}\}$/);

                if (match) {
                  const userId = match[1];
                  const userName = userIdToNameMap[userId] || `User ${userId}`;

                  // Return the styled mention element
                  return (
                    <span key={index} className="text-blue-800 px-1 rounded">
                      @{userName}
                    </span>
                  );
                }

                // Return regular text parts as they are
                return <span key={index}>{part}</span>;
              });
            };

            return (
              <div
                key={index}
                className="rounded-md p-3 cursor-pointer ring-1 ring-gray-200 feedback-delete-hover"
              >
                <div className="flex items-start">
                  <div className="w-[95%] flex flex-col gap-1">
                    <div className="flex justify-start items-center gap-x-2">
                      <span className="flex items-center gap-x-3">
                        {senderImg ? (
                          <img
                            src={`${process.env.REACT_APP_API_BASE_URL}/${senderImg}`}
                            alt={`${senderName || "Profile"}`}
                            className="h-6 w-6 flex-none rounded-full ring-1 ring-gray-900/10"
                          />
                        ) : (
                          <div
                            style={{
                              backgroundColor: getColorForLabel(
                                senderName?.charAt(0) || "",
                              ),
                            }}
                            className="w-6 h-6 rounded-full flex items-center justify-center leading-5"
                          >
                            <span className="font-medium text-white leading-6">
                              {senderName?.charAt(0)}
                            </span>
                          </div>
                        )}
                      </span>
                      <div className="flex gap-x-[6px] items-center">
                        <span className="text-[12px] text-[#374151] font-medium leading-5 capitalize">
                          {senderName}
                        </span>
                        <span className="flex items-center gap-x-[6px] text-xs leading-5 text-gray-500">
                          <span className="flex h-[4px] w-[4px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-[#6b7280]"></span>
                          {formatDistanceToNow(new Date(msg.created_at), {
                            addSuffix: true,
                            includeSeconds: true,
                          })
                            .replace("about ", "")
                            .replace("less than ", "")
                            .replace("half a ", "1 ")}
                        </span>
                      </div>
                    </div>
                    <p className="font-normal text-[#374151] text-[14px] wg-antialiased leading-6 whitespace-break-spaces">
                      {/* {msg.message} */}
                      {renderMessageWithMentions(
                        msg.message,
                        pipelineStageDataUser,
                      )}
                    </p>
                    {msg.attachment && (
                      <div className="mt-2 flex items-center gap-2 bg-gray-100 p-2 rounded-md">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="icon icon-tabler icons-tabler-filled icon-tabler-file-check  w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm3.707 10.293a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292a1 1 0 1 0 -1.414 1.414l2 2a1 1 0 0 0 1.414 0l4 -4a1 1 0 0 0 0 -1.414m-.707 -9.294l4 4.001h-4z" />
                        </svg>

                        {/* <span className="text-sm text-gray-700">{msg.attachment.name}</span> */}
                        <a
                          href={`${process.env.REACT_APP_API_BASE_URL}/${msg.attachment}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-normal text-[#374151] text-[13px] wg-antialiased leading-6 whitespace-pre"
                        >
                          {msg.attachment}
                        </a>
                      </div>
                    )}
                  </div>

                  <div className="w-[5%]">
                    {/* [&>div]:shrink feedback-delete-btn-hover */}
                    {msg.user_id === userId && (
                      <div className="">
                        <CustomMenuDropdown
                          sections={dropdownGroups}
                          icon={
                            <svg
                              stroke="currentColor"
                              fill="none"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                              focusable="false"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="12" cy="12" r="1"></circle>
                              <circle cx="12" cy="5" r="1"></circle>
                              <circle cx="12" cy="19" r="1"></circle>
                            </svg>
                          }
                          menuItemsClassName="left-auto"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      <div className="mt-8 team-textarea">
        <MentionsTextarea
          value={saveMention}
          onChange={handleMentionInputChange}
          placeholder="Write a message..."
          mentionData={mentionData}
        />
        {/* <AutoResizeTextarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write a message..."
        /> */}
        <div className="flex items-center justify-between my-8">
          <div className="relative flex items-center gap-2">
            <label className="cursor-pointer flex items-center gap-2 text-gray-500">
              <Paperclip size={18} />
              <input
                type="file"
                className="hidden"
                onChange={handleFileChange}
              />
            </label>
            {selectedFile && (
              <div className="flex items-center gap-2 bg-gray-100 p-1 px-2 rounded-md text-gray-700">
                <span className="text-sm">{selectedFile.name}</span>
                <X
                  size={16}
                  className="cursor-pointer text-gray-500 hover:text-red-500"
                  onClick={removeFile}
                />
              </div>
            )}
          </div>
          <button
            className="group inline-flex shrink-0 select-none justify-center items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 transition-colors duration-100 
            focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0  rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
            type="button"
            onClick={handlePostMessage}
          >
            <div className="flex items-center  gap-[6px]">
              Post
              {loadingMessage && (
                <div className="simple-spinner">
                  <span></span>
                </div>
              )}
            </div>
          </button>
        </div>
      </div>

      <EditMessageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        message={selectedMessage}
        onSave={handleSave}
        loadingMessageUpdate={loadingMessageUpdate}
        pipelineStageDataUser={pipelineStageDataUser}
      />

      {openDeleteModalExp && (
        <Dialog
          open={true}
          onClose={handleCloseModal}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon />
                  </button>
                </div>
                <div className="flex flex-col gay-y-4">
                  <span className="leading-6 text-sm text-gray-500">
                    Do you want to sure delete this Message?
                  </span>
                </div>
                <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="items-center px-[14px] py-1 text-[13px] font-medium h-[32px] inline-flex leading-6 w-fit justify-center rounded-md bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDeleteConfirm}
                    type="button"
                    className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 "
                  >
                    {deleteLoadingExp ? (
                      <div className="flex items-center gap-[6px]">
                        Delete
                        <div className="simple-spinner">
                          <span></span>
                        </div>
                      </div>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
}

export default JobMessageSection;
